import { modifyCategoryTreeDataHandler } from '@/utils/category';
import { decryptData, encryptData } from '@/utils/encryption';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialValues = {
  categoryTreeData: null,
  menuTreeData: null,
  megaMenuTreeData: null,
  _hasHydrated: false, // Flag to indicate if the store has been hydrated
};

const useCategoryStore = create(
  persist(
    (set) => ({
      ...initialValues,
      setHasHydrated: (state) => {
        set({
          _hasHydrated: state,
        });
      },
      setCategoryTree: (data) =>
        set({
          categoryTreeData: data,
          menuTreeData: modifyCategoryTreeDataHandler(
            'menu',
            data?.children_data
          ),
          megaMenuTreeData: modifyCategoryTreeDataHandler(
            'megaMenu',
            data?.children_data
          ),
        }),
    }),
    {
      name: 'category-store',
      onRehydrateStorage: (state) => {
        return () => state.setHasHydrated(true);
      },
      storage: {
        getItem: (name) => {
          const storedValue = localStorage.getItem(name);
          return storedValue ? decryptData(storedValue) : null;
        },
        setItem: (name, value) => {
          localStorage.setItem(name, encryptData(value));
        },
        removeItem: (name) => {
          localStorage.removeItem(name);
        },
      },
    }
  )
);

export default useCategoryStore;
